export default __webpack_public_path__ + "static/media/statistic.3b09a15d.png";